import url from './url'
const AppConsts = {
    userManagement: {
        defaultAdminUserName: 'admin'
    },
    localization: {
        defaultLocalizationSourceName: 'FengCloud'
    },
    authorization: {
        encrptedAuthTokenName: 'enc_auth_token'
    },
    appBaseUrl: "http://localhost:8055",
    remoteServiceBaseUrl: url
}
export default AppConsts


// WEBPACK FOOTER //
// ./src/lib/appconst.ts